import React from 'react'
import { Icon } from '@chakra-ui/react'

const OrangeCircle = ({ ...props }) => {
  return (
    <Icon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="16" cy="16" r="13.5" stroke="#FFA800" stroke-width="5" />
    </Icon>
  )
}

export default OrangeCircle
